module.exports = __webpack_public_path__ + "img/user-add-icon.327f4edb.svg";